module.exports = __webpack_public_path__ + "static/media/ios-git-compare.92c4be0a.svg";